import { PromptRevision } from "./prompts-types";
import { StoryGenerationRequest } from "./stories-types";
import { StoryConfigRevision } from "./story-configs-types";
import { SubmissionState } from "./submission-types";
import { User } from "./users-types";
import { PaginationParams } from "./utils";

export type EpisodeBase = {
  category: Category;
  gender: Gender;
  id: string;
  modelName: string;
  subcategory: Subcategory;
  state: EpisodeState;
  story: StorySlug;
  submissionState: SubmissionState;
  tags: string[];
  createdAt: string;
  updatedAt: string;
};

export type EpisodeWithUser = EpisodeBase & {
  visualsAssignee: User;
};

export type EpisodeSummarized = EpisodeWithUser & {
  imagesSummary: ImagesSummary;
  masksSummary: MasksSummary;
  hasManualEditImages: boolean;
  state: EpisodeState;
  prompt: {
    name: string;
    revision: string;
  };
  imagePrompt: {
    name: string;
    revision: string;
  };
};

export type EpisodeDetails = EpisodeWithUser & {
  pages: {
    id: string;
    text: string;
    pageNumber: number;
    illustration: string;
  }[];
  textRejectionReasons?: string[];
  pageSize?: string;
  numberOfPages?: number;
  prompt: PromptRevision;
  imagePrompt: PromptRevision | null;
  config: StoryConfigRevision | null;
};

export enum Gender {
  "boy" = "boy",
  "girl" = "girl",
}

export enum StorySlug {
  "wonderland" = "wonderland",
  "frankenstein" = "frankenstein",
  "mermaid" = "mermaid",
  "pooh" = "pooh",
  "sherlock" = "sherlock",
  "neverland" = "neverland",
  "pete_the_cat" = "pete_the_cat",
}

export enum ValidationState {
  "accepted" = "accepted",
  "new" = "new",
  "rejected" = "rejected",
}

export enum EpisodeState {
  "waitingForText" = "waitingForText",
  "textFailed" = "textFailed",
  "pending" = "pending",
  "accepted" = "accepted",
  "rejected" = "rejected",
}

export enum Category {
  "music" = "music",
}

export enum Subcategory {
  "rock" = "rock",
}

// only used for image summary purpose, probably will be deleted soon
export enum DisplayedImageState {
  "waiting" = "waiting", // waiting for initial generation or waiting for regeneration
  "new" = "new", // new or regenerated
  "accepted" = "accepted",
  "rejected" = "rejected",
  "submitted" = "submitted", // accepted and cannot be rejected anymore
}

// only used for masks summary purpose, probably will be deleted soon
export enum DisplayedMaskState {
  "waiting" = "waiting", // waiting for initial generation or waiting for regeneration
  "new" = "new", // new or regenerated
  "accepted" = "accepted",
  "rejected" = "rejected",
  "submitted" = "submitted", // accepted and cannot be rejected anymore
}

export type ImagesSummary = {
  [K in DisplayedImageState]: number;
};

export type MasksSummary = {
  [K in DisplayedMaskState]: number;
};

export type GridRequestQueryParams = {
  orderDirection?: "ASC" | "DESC";
  orderBy?: keyof EpisodeBase;
} & PaginationParams &
  Record<string, string>;

export type PostEpisodeData = {
  items: StoryGenerationRequest[];
};
